import { admin_modal_toggled } from '../actions/types';

const INITIAL_STATE = {
  adminModalOpen: false
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case admin_modal_toggled:
      return { ...state, adminModalOpen: !state.adminModalOpen };

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/AdminReducer.js